import { render, staticRenderFns } from "./PinAuth.vue?vue&type=template&id=520867aa"
import script from "./PinAuth.vue?vue&type=script&lang=js"
export * from "./PinAuth.vue?vue&type=script&lang=js"
import style0 from "./PinAuth.vue?vue&type=style&index=0&id=520867aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports